export default "__VITE_ASSET__7cfefbaa__"